import { render, staticRenderFns } from "./MergeDataTableForJoinGroup.vue?vue&type=template&id=c0386f3e&scoped=true"
import script from "./MergeDataTableForJoinGroup.vue?vue&type=script&lang=js"
export * from "./MergeDataTableForJoinGroup.vue?vue&type=script&lang=js"
import style0 from "./MergeDataTableForJoinGroup.vue?vue&type=style&index=0&id=c0386f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0386f3e",
  null
  
)

export default component.exports